// extracted by mini-css-extract-plugin
module.exports = {"spinner-border":"_2bDQh","spinner-border-sm":"_3zamN","spinner-grow":"_3Cn0s","spinner-grow-sm":"_2E8Ck"};